import { useState } from 'react';
import { TELEGRAM_MINI_APP_URL } from '../config';

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-cream/95 backdrop-blur border-b border-tea-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        <a href="/" className="flex items-center gap-2" aria-label="Shennong Tea — главная страница">
          <span className="text-xl font-semibold text-tea-800">Shennong Tea</span>
          <span className="text-tea-400 text-sm hidden sm:inline">опт · мин. заказ от 5 кг</span>
        </a>

        <nav className="hidden md:flex items-center gap-6" aria-label="Основная навигация">
          <a href="#catalog" className="text-sm text-tea-600 hover:text-tea-800 transition-colors font-medium">Каталог</a>
          <a href="#how" className="text-sm text-tea-600 hover:text-tea-800 transition-colors">Как это работает</a>
          <a href="#assortment" className="text-sm text-tea-600 hover:text-tea-800 transition-colors">Категории</a>
          <a href="#faq" className="text-sm text-tea-600 hover:text-tea-800 transition-colors">FAQ</a>
          <a
            href={TELEGRAM_MINI_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="px-5 py-2 rounded-lg bg-tea-700 text-white text-sm font-semibold hover:bg-tea-800 transition-colors shadow-sm"
          >
            Каталог в Telegram
          </a>
        </nav>

        <button
          type="button"
          className="md:hidden p-2 text-tea-600"
          onClick={() => setOpen((o) => !o)}
          aria-label="Меню"
        >
          {open ? '✕' : '☰'}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-tea-100 bg-cream px-4 py-4 flex flex-col gap-3">
          <a href="#catalog" className="text-sm text-tea-600 font-medium" onClick={() => setOpen(false)}>Каталог</a>
          <a href="#how" className="text-sm text-tea-600" onClick={() => setOpen(false)}>Как это работает</a>
          <a href="#assortment" className="text-sm text-tea-600" onClick={() => setOpen(false)}>Ассортимент</a>
          <a href="#faq" className="text-sm text-tea-600" onClick={() => setOpen(false)}>FAQ</a>
          <a href={TELEGRAM_MINI_APP_URL} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-tea-700 mt-2">
            Каталог в Telegram →
          </a>
        </div>
      )}
    </header>
  );
}
